import "core-js/stable";
import "regenerator-runtime/runtime";
import './index.css';
import { DateTime } from 'luxon';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import App from './App';
import configActions from './areas/config/actions';
import authConstants from './areas/auth/constants';
import repository from './client/repository';
import storeBuilder from './store';
import appStore from 'utilities/store';
import Keys from 'stateKeys';
import { init } from 'workers/mediator';

const rootElement = document.getElementById('root');

const triggerAndRender = (store, isLoggedIn) => {

    // Trigger an update to the logged in state
    store.dispatch({ type: authConstants.LOGGED_IN_SUCCESS, isLoggedIn });

    init(store);

    // Now the state is known, render the UI
    const root = createRoot(rootElement);
    root.render(<Provider store={store}>
        <App />
    </Provider>);
};

const isStateValid = state => {

    const { location, auth } = state;
    if (!location || !location.valid) {
        return false;
    }

    if (auth && auth.loginDateTime) {
        const loginTime = DateTime.fromJSDate(auth.loginDateTime);
        const diff = loginTime.diffNow().as("minutes");
        // eslint-disable-next-line no-undef
        if (Math.abs(diff) > process.env.SESSION_VALIDITY_MINUTES) {
            return false;
        }
    }

    return true;
};

storeBuilder().then(store => {

    store.dispatch(configActions.getAppConfig());

    const state = store.getState();
    const valid = isStateValid(state);

    const { auth } = store.getState();
    
    if (!valid || auth.showLoginPage === true) {
        appStore.remove(Keys.Auth.TokenKey);
        triggerAndRender(store, false);
    } else {
        repository.auth.isLoggedIn().then(result => {
            triggerAndRender(store, result.isLoggedIn);
        });
    }
}).catch(err => console.error('storeBuilder', err));
